/*
    Implementation to use Redux-Form with checkboxes.
*/
import React from 'react';

import UpwardCheckbox from './UpwardCheckbox';

const UpwardReduxCheckbox = ({ input, ...custom }) => {
   return (<UpwardCheckbox value={!!input.value} onChange={input.onChange} {...custom}/>);
};

export default UpwardReduxCheckbox;
